<template>
  <div class="menu-gallery" ref="menu-gallery">
    <transition name="fade">
      <v-btn
        v-if="offsetLeft > 50"
        absolute
        left
        class="arrow-left-btn grey lighten-3 elevation-1"
        icon
        small
        :ripple="false"
        ><v-icon color="black">mdi-chevron-left</v-icon></v-btn
      >
    </transition>
    <div
      class="gallery-wrap py-2"
      id="gallery-wrap"
      v-scroll:#gallery-wrap="onScroll"
      ref="gallery-wrap"
    >
      <MenuGalleryImage
        v-for="(img, i) of imgs"
        :img="img"
        :key="`${i}-${img.asset_id}`"
        v-intersect="i + 1 === imgs.length ? lastImgIntersect : () => {}"
      />
    </div>
    <transition name="fade">
      <v-btn
        v-if="!isLastImgIntersecting"
        absolute
        right
        class="arrow-right-btn grey lighten-3 elevation-1"
        icon
        small
        :ripple="false"
        ><v-icon color="black">mdi-chevron-right</v-icon></v-btn
      >
    </transition>
  </div>
</template>

<script>
import MenuGalleryImage from '@/components/MenuGalleryImage'
export default {
  name: 'MenuGallery',
  props: {
    imgs: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  components: { MenuGalleryImage },
  data() {
    return {
      offsetLeft: 0,
      offsetRight: Infinity,
      isLastImgIntersecting: false,
    }
  },
  methods: {
    onScroll(e) {
      this.offsetLeft = e.target.scrollLeft
    },
    lastImgIntersect(entries) {
      // More information about these options
      // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      this.isLastImgIntersecting = entries[0].isIntersecting
    },
  },
}
</script>

<style lang="scss" scoped>
.menu-gallery {
  position: relative;
}
.gallery-wrap {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
}
.arrow-right-btn,
.arrow-left-btn {
  position: absolute;
  top: 50%;
  z-index: 4;
  cursor: unset;
  &:focus {
    background-color: white !important;
  }
}
.arrow-right-btn {
  right: 0;
  transform: translateX(50%);
}
.arrow-left-btn {
  transform: translateX(-50%);
  left: 0;
}
</style>
